import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/logo.jpg"
      {...props}
    />
  );
};

export default Logo;
